export const menuDynamicScrollColor = () => {
  const headerWrapper = document.querySelector('.js-header')
  const wrapperElement = document.querySelector('.js-contentWrapper')

  if (!headerWrapper || !wrapperElement) {
    return
  }

  const headerControlLine = headerWrapper.querySelector('.js-header-menuControlLine') as HTMLElement

  const footerElement = document.querySelector('.js-footer') as HTMLElement

  if (!headerControlLine || !footerElement) {
    return
  }

  const allComponents = Array.from(wrapperElement.children) as HTMLElement[]
  allComponents.push(footerElement)

  const allComponentsFiltered = allComponents.filter(component => {
    const blacklistTagsNames = [
      'SCRIPT'
    ]

    if (blacklistTagsNames.includes(component.tagName)) {
      return false
    }
    else {
      return true
    }
  })

  // On scrolling
  window.addEventListener('scroll', () => {
    checkDynamicColor()
  })

  // On resize
  window.addEventListener('resize', () => {
    checkDynamicColor()
  })

  const checkDynamicColor = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    allComponentsFiltered.forEach((component) => {
      const componentTop = component.offsetTop

      if (componentTop < scrollTop + 40) {
        const componentColor = component.getAttribute('data-coloring')

        if (componentColor === 'dark') {
          headerControlLine.classList.remove('-inverted')
        }
        else {
          headerControlLine.classList.add('-inverted')
        }
      }
    })
  }

  checkDynamicColor()
}
